/**
 * The demo block cubic writes into a pull request's description (`renderDemoVideoBlock`), as text:
 * its markers, and putting it in or taking it out. No server imports: the pull request page takes
 * it out where it shows the demo itself.
 */
export const DEMO_VIDEO_START_MARKER = '<!-- cubic:demo-video:start -->';
export const DEMO_VIDEO_END_MARKER = '<!-- cubic:demo-video:end -->';

/** Where the description's demo block starts, and where it ends past its end marker. */
function demoVideoBlockRange(body: string): { start: number; end: number } | null {
  const firstStart = body.indexOf(DEMO_VIDEO_START_MARKER);
  if (firstStart === -1) {
    return null;
  }
  const endMarker = body.indexOf(
    DEMO_VIDEO_END_MARKER,
    firstStart + DEMO_VIDEO_START_MARKER.length,
  );
  if (endMarker === -1) {
    return null;
  }
  // The start nearest the end: a start marker left alone earlier must not take the text after it.
  const start = body.lastIndexOf(DEMO_VIDEO_START_MARKER, endMarker);
  return { start, end: endMarker + DEMO_VIDEO_END_MARKER.length };
}

/**
 * The description with `block` in place of its demo block, or after it, past a blank line, when
 * it has none. Everything else stays as the author wrote it.
 */
export function withDemoVideoBlock(body: string | null, block: string): string {
  if (!body) {
    return block;
  }
  const range = demoVideoBlockRange(body);
  if (range === null) {
    return `${body}\n\n${block}`;
  }
  return `${body.slice(0, range.start)}${block}${body.slice(range.end)}`;
}

/** The description without its demo block, for a page that shows the demo itself. */
export function withoutDemoVideoBlock(body: string): string {
  const range = demoVideoBlockRange(body);
  if (range === null) {
    return body;
  }
  const beforeBlock = body.slice(0, range.start);
  // Remove only the separator `withDemoVideoBlock` added, preserving the author's whitespace.
  const prefix = beforeBlock.endsWith('\n\n') ? beforeBlock.slice(0, -2) : beforeBlock;
  return `${prefix}${body.slice(range.end)}`;
}
